import { useCopies } from "shared/hooks/useCopies";
import { useParticipantDetails } from "../../../../context/participantDetails";
import React from "react";
import { ATTENDEE_PARTICIPANT_TYPES } from "../../../../../../shared/enums/ProgramParticipantType";

export default function GenericInfoDetails() {
  const copies = useCopies();
  const { participantDetails } = useParticipantDetails();
  const isProgramParticipant = React.useMemo(() => {
    return Boolean(
      participantDetails?.events?.find(e =>
        e.programs?.find(p =>
          p.programParticipants.find(pp => ATTENDEE_PARTICIPANT_TYPES.includes(pp.programParticipantType))
        )
      )
    );
  }, [participantDetails?.events]);

  return (
    <div className="genericInfoDetails iconLabel">
      {isProgramParticipant && (
        <div dangerouslySetInnerHTML={{ __html: copies.get("upgrade.ticket.program.participant.info.message") }} />
      )}
      {copies.get("upgrade.ticket.info.message")}
    </div>
  );
}
